import {
  GoogleAuthProvider,
  signInWithCredential,
} from 'firebase/auth';
import { auth } from './firebase';

const AUTH_ERROR_COPY = Object.freeze({
  'auth/account-exists-with-different-credential': 'This email already uses another sign-in method.',
  'auth/email-already-in-use': 'An account already exists for this email.',
  'auth/invalid-credential': 'Email or password is incorrect.',
  'auth/invalid-email': 'Enter a valid email address.',
  'auth/invalid-login-credentials': 'Email or password is incorrect.',
  'auth/network-request-failed': 'Check your internet connection and try again.',
  'auth/popup-blocked': 'Allow pop-ups to continue with Google.',
  'auth/too-many-requests': 'Too many attempts. Wait a moment and try again.',
  'auth/unauthorized-domain': 'Google sign-in is not enabled for this site.',
  'auth/user-disabled': 'This account is disabled. Contact support.',
  'auth/user-not-found': 'Email or password is incorrect.',
  'auth/weak-password': 'Use a stronger password with at least 6 characters.',
  'auth/wrong-password': 'Email or password is incorrect.',
});

export function cleanFirebaseError(error) {
  const code = typeof error === 'object' && error !== null ? error.code : '';
  const message = typeof error === 'string' ? error : error?.message || '';
  const embeddedCode = message.match(/\((auth\/[^)]+)\)/)?.[1] || '';
  const resolvedCode = code || embeddedCode;
  if (AUTH_ERROR_COPY[resolvedCode]) return AUTH_ERROR_COPY[resolvedCode];

  const cleaned = message
    .replace(/^Firebase:\s*/, '')
    .replace(/\s*\(auth\/[^)]*\)\.?/, '')
    .trim();
  return cleaned && cleaned !== 'Error' ? cleaned : 'Sign-in failed. Try again.';
}

export async function nativeGoogleSignIn() {
  const { registerPlugin } = await import('@capacitor/core');
  const GoogleSignInPlugin = registerPlugin('GoogleSignInPlugin');
  const { idToken, accessToken } = await GoogleSignInPlugin.signIn();
  const credential = GoogleAuthProvider.credential(idToken, accessToken);
  return signInWithCredential(auth, credential);
}
